/* eslint-disable no-useless-escape */
export const rules = {
  regexp: {
    // Notes:
    //  \w (word) is short for a-zA-Z0-9_
    //  À-ÿ matches subset of accents, umlauts etc.
    alphaNumericWithSpecialChars: /^[\wÀ-ÿ\-.,:;/'`´"& ]*$/,
    alphaNumericWithExtendedSpecialChars: /^[\wÀ-ÿ\-.,:;/'`´"&!¡?¿=%€$¢£ \n]*$/,
    alphaWithSpecialChars: /^[a-zA-Z_À-ÿ\-.,:;/'`´"& ]*$/,
    printableAsciiWithLatin1SpecialLetters: /^[ -~À-ÿ]*$/,
    printableAsciiWithLatin1SpecialLettersAndNewlineAndCurrencySymbols:
      /^[ -~À-ÿ\n\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]*$/,
    alpha: /^[a-zA-Z]*$/,
    numeric: /^[0-9]*$/,
    phoneNumber: /^((\+?[1-9])|0)(\s*\d){1,14}$/,
    email:
      /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*((\.[A-Za-z]{2,}){1}$)/,
    website: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
  },
  maxLength: {
    global: {
      streetAddress: 45,
      streetAddress2: 45,
      zipCode: 9,
      city: 45,
      phoneNumber: 20,
      reference: 30,
      additionalDetails: 80,
      projectId: 5,
      externalOrderNumber: 35,
    },
    finnish: {
      streetAddress: 100,
      streetAddress2: 50,
      zipCode: 5,
      city: 30,
      phoneNumber: 15,
      personName: 200,
    },
  },
  minLength: {
    global: {
      projectId: 5,
    },
    finnish: {
      zipCode: 5,
    },
    us: {
      phoneNumber: 9, // UPS requires at least 10 alphanumeric characters for US and the prefix "+1" makes 1
    },
  },
};
